import React from 'react';
import useGameStore from '../../store/gameStore';
import { Link } from 'react-router-dom';
import { computeAmelFx, bilanAmeliorations } from '../../utils/ameliorations';
import { formatMoney } from '../../utils/format';
import { Hammer, ArrowRight } from 'lucide-react';

/* SCD R3 — Effets visibles des investissements (améliorations) sur le Dashboard. */
const Chip = ({ label, value, positive = true, testId }) => (
  <span
    className={`inline-flex items-center gap-1.5 border rounded-full px-2.5 py-1 text-[11px] font-mono ${positive ? 'bg-emerald-600/15 text-emerald-400 border-emerald-700/50' : 'bg-ink-700/60 text-slate-300 border-ink-600'}`}
    data-testid={testId}
  >
    <span className="font-sans font-medium">{label}</span> {value}
  </span>
);

export default function InvestissementsCard() {
  const retail = useGameStore(s => s.retail);
  if (!retail?.magasin) return null;
  const fx = computeAmelFx(retail.magasin);
  const bilan = bilanAmeliorations(retail);
  const satPts = Math.round(fx.satisfactionJour / 0.02);

  return (
    <div className="surface-card overflow-hidden" data-testid="investissements-card">
      <div className="px-4 py-2.5 border-b border-ink-600 flex items-center justify-between">
        <h3 className="font-display text-xs font-bold text-foreground tracking-tight uppercase flex items-center gap-2">
          <Hammer className="w-3.5 h-3.5 text-accent" /> Effet de vos investissements
        </h3>
        <Link to="/magasin" className="text-[11px] font-bold text-accent hover:underline inline-flex items-center gap-1" data-testid="investissements-lien-magasin">
          Évolution du magasin <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
      {bilan.nbTotal === 0 ? (
        <p className="p-3 text-[11px] text-slate-500" data-testid="investissements-vide">
          Aucune amélioration achetée pour l'instant. Investissez dans votre magasin (merchandising, réserve, caisses, services…) et mesurez ici leur effet sur le trafic et le panier.
        </p>
      ) : (
        <div className="p-3 flex flex-wrap items-center gap-2" data-testid="investissements-effets">
          {fx.traficPct > 0 && <Chip label="Trafic" value={`+${fx.traficPct} %`} testId="invest-trafic" />}
          {fx.conversionPct > 0 && <Chip label="Conversion" value={`+${fx.conversionPct} %`} testId="invest-conversion" />}
          {fx.panierPct > 0 && <Chip label="Panier moyen" value={`+${fx.panierPct} %`} testId="invest-panier" />}
          {satPts > 0 && <Chip label="Satisfaction" value={`+${satPts} pts`} testId="invest-satisfaction" />}
          {fx.capaciteReservePct > 0 && <Chip label="Réserve" value={`+${fx.capaciteReservePct} %`} testId="invest-reserve" />}
          <span className="ml-auto text-[11px] font-mono text-slate-400" data-testid="invest-bilan">
            {bilan.nbTotal} amélioration{bilan.nbTotal > 1 ? 's' : ''} · {formatMoney(bilan.totalInvest)} investis · entretien {formatMoney(bilan.entretienMois)}/mois
          </span>
        </div>
      )}
    </div>
  );
}
